export default [
    {
        name: 'sidewalkModel',
        type: 'gltfModel',
        path: 'models/sidewalk.glb'
    },
    {
        name: 'sidewalkTexture',
        type: 'texture',
        path: 'textures/sidewalk.jpg'
    },
    {
        name: 'roadModel',
        type: 'gltfModel',
        path: 'models/road.glb'
    },
    {
        name: 'roadTexture',
        type: 'texture',
        path: 'textures/road.jpg'
    },
    {
        name: 'intersectionModel',
        type: 'gltfModel',
        path: 'models/intersection.glb'
    },
    {
        name: 'intersectionTexture',
        type: 'texture',
        path: 'textures/intersection.jpg'
    },
    {
        name: 'crosswalkModel',
        type: 'gltfModel',
        path: 'models/crosswalk.glb'
    },
    {
        name: 'crosswalkTexture',
        type: 'texture',
        path: 'textures/crosswalk.jpg'
    },
    {
        name: 'curbModel',
        type: 'gltfModel',
        path: 'models/curb.glb'
    },
    {
        name: 'grassFloorModel',
        type: 'gltfModel',
        path: 'models/grassFloor.glb'
    },
    {
        name: 'grassFloorTexture',
        type: 'texture',
        path: 'textures/grassFloor.jpg'
    },
    {
        name: 'stonePathModel',
        type: 'gltfModel',
        path: 'models/stonePath.glb'
    },
    {
        name: 'stonePathTexture',
        type: 'texture',
        path: 'textures/stonePath.jpg'
    },
    {
        name: 'fenceModel',
        type: 'gltfModel',
        path: 'models/fence.glb'
    },
    {
        name: 'pondWallModel',
        type: 'gltfModel',
        path: 'models/pondWall.glb'
    },
    {
        name: 'pondModel',
        type: 'gltfModel',
        path: 'models/pond.glb'
    },
    {
        name: 'buildingBrickModel',
        type: 'gltfModel',
        path: 'models/buildingBrick.glb'
    },
    {
        name: 'buildingBrickTexture',
        type: 'texture',
        path: 'textures/buildingBrick.jpg'
    },
    {
        name: 'buildingRoofBlackModel',
        type: 'gltfModel',
        path: 'models/buildingRoofBlack.glb'
    },
    {
        name: 'buildingRoofWhiteModel',
        type: 'gltfModel',
        path: 'models/buildingRoofWhite.glb'
    },
    {
        name: 'buildingRoofWhiteTexture',
        type: 'texture',
        path: 'textures/buildingRoofWhite.jpg'
    },
    {
        name: 'domeModel',
        type: 'gltfModel',
        path: 'models/dome.glb'
    },
    {
        name: 'domeTexture',
        type: 'texture',
        path: 'textures/dome.jpg'
    },
    {
        name: 'doorHandleModel',
        type: 'gltfModel',
        path: 'models/doorHandle.glb'
    },
    {
        name: 'doorWoodModel',
        type: 'gltfModel',
        path: 'models/doorWood.glb'
    },
    {
        name: 'doorWoodTexture',
        type: 'texture',
        path: 'textures/doorWood.jpg'
    },
    {
        name: 'doorFrameModel',
        type: 'gltfModel',
        path: 'models/doorFrame.glb'
    },
    {
        name: 'doorFrameTexture',
        type: 'texture',
        path: 'textures/doorFrame.jpg'
    },
    {
        name: 'clockModel',
        type: 'gltfModel',
        path: 'models/clock.glb'
    },
    {
        name: 'stairsModel',
        type: 'gltfModel',
        path: 'models/stairs.glb'
    },
    {
        name: 'poleLightStoneModel',
        type: 'gltfModel',
        path: 'models/poleLightStone.glb'
    },
    {
        name: 'poleLightPillarModel',
        type: 'gltfModel',
        path: 'models/poleLightPillar.glb'
    },
    {
        name: 'poleLightBulbModel',
        type: 'gltfModel',
        path: 'models/poleLightBulb.glb'
    },
    {
        name: 'chimneyBrickModel',
        type: 'gltfModel',
        path: 'models/chimneyBrick.glb'
    },
    {
        name: 'chimneyRoofModel',
        type: 'gltfModel',
        path: 'models/chimneyRoof.glb'
    },
    {
        name: 'chimneyBrickTexture',
        type: 'texture',
        path: 'textures/chimneyBrick.jpg'
    },
    {
        name: 'windowGlassModel',
        type: 'gltfModel',
        path: 'models/windowGlass.glb'
    },
    {
        name: 'windowGlassTexture',
        type: 'texture',
        path: 'textures/windowGlass.jpg'
    },
    {
        name: 'windowFrameModel',
        type: 'gltfModel',
        path: 'models/windowFrame.glb'
    },
    {
        name: 'grassModel',
        type: 'gltfModel',
        path: 'models/grass.glb'
    },
]